module.exports = __webpack_public_path__ + "img/22364c1eb85806911cf78e37363d6b44.png";